// extracted by mini-css-extract-plugin
export default {"container":"VerifyPayment_container__uKlh0"};